module.exports = __webpack_public_path__ + "static/trykorero-219a2aa7fff657cfb6883a0175ab454a.jpg";